import { AxiosInstance } from "axios";
import { APIResponse } from "@/customTypes/NetworkTypes";
import NetworkUtil from "@/projectUtils/NetworkUtil";
import { apiEndpoints } from "./axiosConfig/AxiosServiceConstants";
import { iPurchaseOrderDTO} from "@/redux/POSection/Types";
function AddPurchaseOrderService(apiServer: AxiosInstance) {

  const getToken = (): string | null => {
    return localStorage.getItem("userToken");
  };

  const addPruchaseOrderProduct = async (data: iPurchaseOrderDTO): Promise<APIResponse<any> | null> => {
    let result = null;
    const token = getToken();


    await apiServer
      .post(apiEndpoints.addPurchaseOrderData.addPruchaseOrderProduct(), data, {
        headers: {
          "Content-Type": "application/json",
           Authorization: token,
        },
        
      })
      .then(
        (value) => {
          result = NetworkUtil.buildResult<any>(null, value.status, null, value.data);
        },
        (reason) => {
          const { response } = reason;
          const { status, data } = response;
          result = NetworkUtil.buildResult<null>(data, status, data, null);
        }
      )
      .catch((error) => {
        throw error;
      });

    return result;
  };

 const getPruchaseOrderProduct = async (): Promise<APIResponse<iPurchaseOrderDTO[]> | null> => {
      let result = null;
      const token = getToken();
  
      await apiServer
        .get(apiEndpoints.addPurchaseOrderData.getPruchaseOrderProduct(), {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        })
        .then(
          (value) => {
            result = NetworkUtil.buildResult<iPurchaseOrderDTO[]>(null, value.status, null, value.data);
          },
          (reason) => {
            const { response } = reason;
            const { status, data } = response;
            result = NetworkUtil.buildResult<null>(data, status, data, null);
          }
        )
        .catch((error) => {
          throw error;
        });
  
      return result;
    };


  return {
    addPruchaseOrderProduct,
    getPruchaseOrderProduct,
  };
}

export default AddPurchaseOrderService;
